import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import Paper from '@material-ui/core/Paper';
import groupBy from 'lodash.groupby';
import React from 'react';
import { Link } from 'react-router-dom';
import AddDialog from '../AcceptNewCriteriaDialog';
import 'CSS/dashboard-tickets.scss';
import API from '../../../../../../api';
import TicketModal from '../ViewTicketModal';
import OpticalDistributionImage from '../../../OpticalDistributionImage';
import CriteriaImage from 'CriteriaImage';
import { API_ROOT } from 'Api/Routes';
import FavButton from './components/FavButton';
import styled from 'styled-components';

const TicketName = styled.div`
  width: 100px;
`;

class SidebarTicketCard extends React.Component {
  groupByHierarchy = () => {
    if (this.props.ticket.queryCriteria) {
      return groupBy(
        this.props.ticket.queryCriteria,
        criteria => criteria.hierarchy
      );
    }
  };

  state = {
    newProjectDialogOpen: false,
    anchorEl: null,
    showHover: false,
    deleteDialog: false,
    value: 0,
    groupedCriteria: this.groupByHierarchy(),
    hierarchy1: '1',
    hierarchy2: '2',
    openModal: false,
    viewThisTicket: null,
    error: null,
    addDialog: false,
  };

  openAddDialog = () => {
    API.checkCriteriaIfExists(this.props.ticket.ticketId)
      .then(res => {
        if (res) {
          if (res.data) {
            this.setState({ addDialog: true });
          } else {
            this.setState({ showHover: false });
            this.handleClose();
            this.closeAddDialog();
            this.props.history.push({
              pathname: `/demand/project/${this.props.projectId}/ticket/create`,
              state: {
                projectId: this.props.ticket.projectId,
                ticketId: this.props.ticket.ticketId,
                isReuse: true,
              },
            });
          }
        }
      })
      .catch(error => {
        this.setState(
          state => ({
            error,
          }),
          () => {
            this.closeAddDialog();
          }
        );
      });
  };

  closeAddDialog = () => {
    this.setState({ addDialog: false });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handleOpenEditDialog = () => {
    this.setState({ newProjectDialogOpen: true });
    this.handleClose();
  };
  handleCloseEditDialog = () => {
    this.setState({ newProjectDialogOpen: false });
  };
  openDeleteDialog = () => {
    this.setState({ deleteDialog: true });
  };
  closeDeleteDialog = () => {
    this.setState({ deleteDialog: false });
  };

  renderQueryCriteria = () => {
    let returnString = [];
    returnString[1] = '';
    returnString[2] = '';
    if (this.props.ticket && this.props.ticket.ticketCriteria) {
      this.props.ticket.ticketCriteria.forEach((qCriteria, index) => {
        if (
          !(
            qCriteria.criteriaId === 270 ||
            qCriteria.criteriaId === 323 ||
            qCriteria.criteriaId === 325 ||
            qCriteria.criteriaId === 391 ||
            qCriteria.criteriaId === 320 ||
            qCriteria.criteriaId === 132 ||
            qCriteria.criteriaId === 389 ||
            qCriteria.criteriaId === 318 ||
            qCriteria.criteriaId === 322 ||
            qCriteria.criteriaId === 321 ||
            qCriteria.criteriaId === 319 ||
            qCriteria.criteriaId === 324 ||
            qCriteria.criteriaId === 330
          )
        ) {
          returnString[qCriteria.hierarchy] += qCriteria.name;
        }
        if (qCriteria.criteriaId === 270) {
          returnString[qCriteria.hierarchy] += 'IP';
        }
        if (qCriteria.value) {
          returnString[qCriteria.hierarchy] += ' ';
          returnString[qCriteria.hierarchy] += qCriteria.value.toString();
          if (qCriteria.unit) {
            returnString[qCriteria.hierarchy] += qCriteria.unit.toString();
          }
        }
        if (this.props.ticket.ticketCriteria[index + 1]) {
          returnString[qCriteria.hierarchy] += ', ';
        }
      });
      return (
        <div>
          {returnString[1] !== '' && (
            <p className="ticket-hierarchy boldThis">{returnString[1]}</p>
          )}
          {returnString[2] !== '' && (
            <p className="ticket-hierarchy ticket-hierarchy--grey">
              {returnString[2]}
            </p>
          )}
        </div>
      );
    }
  };

  handleOpenModal = () => {
    // this.setState({ openModal: true });
    this.getCurrentTicket();
  };

  getCurrentTicket = () => {
    if (!this.props.ticket.projectId || !this.props.ticket.ticketId) return;
    API.getTicket(this.props.ticket.projectId, this.props.ticket.ticketId)
      .then(res => {
        this.setState(state => ({
          viewThisTicket: res.data,
          openModal: true,
        }));
        this.handleClose();
      })
      .catch(error => {
        this.setState(state => ({
          error,
        }));
      });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  checkForNewCriteria = () => event => {
    // this.setState({ redirectToCreatePage: true });

    API.setNewCustomCriteriaToMyDefault(this.props.ticket.ticketId)
      .then(res => {
        this.setState({ showHover: false });
        this.handleClose();
        this.closeAddDialog();
        this.props.history.push({
          pathname: `/demand/project/${this.props.projectId}/ticket/create`,
          state: {
            projectId: this.props.ticket.projectId,
            ticketId: this.props.ticket.ticketId,
            isReuse: true,
          },
        });
      })
      .catch(error => {
        this.setState(
          state => ({
            error,
          }),
          () => {
            this.closeAddDialog();
          }
        );
      });
  };

  render() {
    const { anchorEl } = this.state;
    return this.props.ticket ? (
      <Grid container justify="center">
        <Grid item xs={10}>
          <Paper
            onMouseEnter={() => {
              this.setState({ showHover: true });
            }}
            onMouseLeave={() => {
              this.setState({ showHover: false });
            }}
            className=" favorite-tickets project-card sidebar-tickets"
          >
            {/*{this.state.showHover && (*/}
            {/*<div className="project-card-hover">*/}
            {/*<div className="project-card-hover-top">*/}
            {/**/}
            {/*</div>*/}
            {/*<Button*/}
            {/*variant="text"*/}
            {/*className="hollow-button"*/}
            {/*onClick={this.handleOpenModal}*/}
            {/*>*/}
            {/*View search*/}
            {/*</Button>*/}
            {/*</div>*/}
            {/*)}*/}

            <div className="ticket-card-basic sidebar-tickets-main">
              <div className="ticket-image">
                <OpticalDistributionImage
                  icon={this.props.ticket.opticalDistributionCriteriaId}
                />
                <CriteriaImage
                  iconCombination={this.props.ticket.ticketImageName}
                />
                {this.props.ticket &&
                this.props.ticket.assets &&
                this.props.ticket.assets[0] ? (
                  <div
                    style={{
                      backgroundImage: `url(${API_ROOT +
                        '/asset/' +
                        this.props.ticket.assets[0]})`,
                    }}
                  />
                ) : (
                  <div />
                )}
                {this.props.ticket &&
                this.props.ticket.assets &&
                this.props.ticket.assets[1] ? (
                  <div
                    style={{
                      backgroundImage: `url(${API_ROOT +
                        '/asset/' +
                        this.props.ticket.assets[1]})`,
                    }}
                  />
                ) : (
                  <div />
                )}
              </div>
              <TicketName className="sidebar-tickets-description">
                <div className="t-primary-16 ticket-basic-title element-inline-block">
                  <b>{this.props.ticket.referenceName}</b>{' '}
                  <span>{this.props.ticket.name}</span>
                </div>
                {this.renderQueryCriteria()}
              </TicketName>
            </div>
            <div className="project-card-hover-menu">
              <IconButton
                aria-label="More"
                aria-owns={anchorEl ? 'long-menu' : null}
                aria-haspopup="true"
                onClick={this.handleClick}
                className="sidebar-tickets-icon-button"
              >
                <MoreHoriz className="project-card-hover-more-icon" />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem
                  key={1}
                  // onClick={this.checkForNewCriteria(
                  //   this.props.ticket.projectId,
                  //   this.props.ticket.ticketId,
                  //   true
                  // )}
                  onClick={this.openAddDialog}
                >
                  Reuse
                </MenuItem>
                <MenuItem
                  key={2}
                  onClick={() => {
                    this.handleOpenModal();
                  }}
                >
                  View Search
                </MenuItem>
              </Menu>
            </div>
            <FavButton
              favorited={this.props.ticket.favorite}
              projectId={this.props.ticket.projectId}
              ticketId={this.props.ticket.ticketId}
            />
          </Paper>
        </Grid>
        {this.state.openModal && (
          <TicketModal
            openModal={this.state.openModal}
            handleCloseModal={this.handleCloseModal}
            viewThisTicket={this.state.viewThisTicket}
            {...this.props}
          />
        )}
        <AddDialog
          doAdd={this.checkForNewCriteria()}
          handleClose={this.closeAddDialog}
          isOpen={this.state.addDialog}
        />
      </Grid>
    ) : null;
  }
}

export default SidebarTicketCard;
